import { Modal } from 'react-bootstrap';

import { useTranslate } from 'hooks/useTranslate';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import PageWithTabs from 'modules/_shared/components/Pages/PageWithTabs';

import { useSyncEmployees } from './hooks/useSyncEmployees';
import SyncMatchingTable from './components/SyncMatchingTable';
import SyncNotMatchingTable from './components/SyncNotMatchingTable';

import '../Modals.scss';

function SyncEmployeesModal() {
  const { t } = useTranslate();
  const {
    data: {
      comparison,
      isLoading,
      error,
      isSynchronizing,
      matchingEntries,
      notMatchingList,
      matchingPaginated,
      notMatchingPaginated,
      firstMatchingNr,
      firstNotMatchingNr,
      employeeOptions,
      matchingPagination,
      notMatchingPagination,
      notMatchingSelections,
      hasUpdatesToSync,
      alreadyLinkedEmployeeIds,
    },
    actions: {
      handleClose,
      handleNotMatchingSelect,
      handleSynchronize,
      setMatchingPagination,
      setNotMatchingPagination,
    },
  } = useSyncEmployees();

  const tabs = [
    {
      key: 'matching',
      title: `${t('SyncMatchingTab')} (${matchingEntries.length})`,
      content: (
        <SyncMatchingTable
          matchingPaginated={matchingPaginated}
          firstMatchingNr={firstMatchingNr}
          matchingEntries={matchingEntries}
          matchingPagination={matchingPagination}
          setMatchingPagination={setMatchingPagination}
        />
      ),
    },
    {
      key: 'not-matching',
      title: `${t('SyncNotMatchingTab')} (${notMatchingList.length})`,
      content: (
        <SyncNotMatchingTable
          notMatchingPaginated={notMatchingPaginated}
          firstNotMatchingNr={firstNotMatchingNr}
          notMatchingList={notMatchingList}
          notMatchingPagination={notMatchingPagination}
          employeeOptions={employeeOptions}
          notMatchingSelections={notMatchingSelections}
          matchingEmployeeIds={matchingEntries.map((e) => e.employee._id)}
          alreadyLinkedEmployeeIds={alreadyLinkedEmployeeIds}
          setNotMatchingPagination={setNotMatchingPagination}
          onEmployeeSelect={handleNotMatchingSelect}
        />
      ),
    },
  ];

  return (
    <>
      <Modal.Header>
        <h5 className="modal-title mb-0">
          {t('SyncEmployeesBeneficiariesTitle')}
        </h5>
        <a className="close cursor-pointer" onClick={handleClose}>
          <em className="icon ni ni-cross" />
        </a>
      </Modal.Header>
      <Modal.Body>
        {isLoading && <CustomLoading />}
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        {!isLoading && !error && comparison && (
          <>
            {matchingEntries.length === 0 && notMatchingList.length === 0 ? (
              <p className="text-soft">{t('NoBeneficiariesToCompare')}</p>
            ) : (
              <PageWithTabs
                id="sync-employees-tabs"
                tabs={tabs}
                removeHorizontalPadding
              />
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-lg btn-primary"
          onClick={handleSynchronize}
          disabled={isSynchronizing || isLoading || !hasUpdatesToSync}
        >
          <em className="icon ni ni-reload mr-1" />
          {t('Synchronize')}
        </button>
      </Modal.Footer>
    </>
  );
}

export default SyncEmployeesModal;
